var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseList',{attrs:{"fields":_vm.fields,"icon":"fa fa-trash-o","tooltip":"Reset","plural":"metadata entries","success":"successful","getter":_vm.getter,"setter":_vm.setter}})
}
var staticRenderFns = []

export { render, staticRenderFns }